import { Injectable, inject } from "@angular/core";
import { INgxLoadingConfig, NgxLoadingConfig } from "./ngx-loading-config";

@Injectable({
  providedIn: "root",
})
export class NgxLoadingService {
  private config = inject<INgxLoadingConfig>("loadingConfig" as any, { optional: true });

  public loadingConfig: INgxLoadingConfig;

  constructor() {
    this.loadingConfig = this.config || new NgxLoadingConfig();
  }
}
